/* NF Front-Finder Quiz (UX-Test-Theme, Entwurf 2026-10-05) – ClickUp 86cav7u3m.
   Markup + Live-Daten: sections/nf-front-finder.liquid (JSON in [data-ff-data]); Look: assets/nf-front-finder.css.

   Ablauf: Start → 6 Fragen (Kurzfassung: 4) → Ergebnis. Tippen = antworten, „Zurück“ und Browser-Zurück gehen
   eine Frage zurück, Antworten bleiben in dieser Sitzung erhalten (sessionStorage, 30 Min).

   ---------------------------------------------------------------------------------------------------------------
   EMPFEHLUNGS-LOGIK (vollständig – jede Antwort-Kombination ergibt einen gültigen Style + 3 Farben)
   ---------------------------------------------------------------------------------------------------------------
   1) Style = Frage 5 (Charakter) × Frage 6 (Griffe) → Präferenzliste (Tabelle PREF unten). Genommen wird der
      erste Style, den es für System (Frage 1) + Oberfläche (Frage 2) gibt. „Gibt es“ = das Konfigurator-Produkt
      steht in der Kollektion (STYLES[..].h) – fällt ein Produkt weg, rutscht das Quiz automatisch weiter.
      Verfügbarkeit Stand 05.10.2026:
                        METOD                         PAX
                        Matt  Holz Fein  Rustikal     Matt  Holz Fein  Rustikal
        Standard         ✓       ✓          ✓          ✓       ✓          ✓
        Rahmen (normal)  ✓       ✓          –          ✓       ✓          –
        Rahmen (schmal)  ✓       ✓          –          ✓       –          –
        Rahmen (oval)    ✓       –          –          ✓       –          –
        Modern           ✓       ✓          ✓          ✓       ✓          ✓
        Iconic           ✓       ✓          ✓          ✓       ✓          ✓
        Liniert          ✓       ✓          –          –       –          –
      Alternative („Auch passend“) = nächster verfügbarer Style der Liste, sonst Modern → Iconic → Standard.
      Bei „Klassische Griffe“ nur Styles mit aufgesetztem Griff (ALT_GRIFFE) – gibt es keinen, fällt die Karte weg.
      Ausnahme: „Klassisch mit Rahmen“ + „Grifflos“ → Rahmen-Style, Alternative immer Modern (die grifflose Wahl).
      Ist ein Wunsch nicht erfüllbar, greift die „Warum“-Zeile ihn auf (Holz Rustikal ohne Rahmen · „Markant“ ohne
      markanten Style bei Holz Rustikal / PAX Holz Fein); nur „Rahmen + grifflos“ bekommt zusätzlich eine Hinweis-Zeile.
      Ergebnis je Kombination (aus PREF + Verfügbarkeit; identisch mit quiz-data.json bis auf die Ausnahme oben):
        Charakter | Griffe   | METOD Matt       | METOD Holz Fein | METOD Rustikal | PAX Matt        | PAX Holz Fein   | PAX Rustikal
        ruhig     | grifflos | Modern           | Modern          | Modern         | Modern          | Modern          | Modern
        ruhig     | griffe   | Standard         | Standard        | Standard       | Standard        | Standard        | Standard
        ruhig     | egal     | Standard         | Standard        | Standard       | Standard        | Standard        | Standard
        rahmen    | grifflos | Rahmen (schmal)* | Rahmen (schmal)*| Modern°        | Rahmen (schmal)*| Rahmen (normal)*| Modern°
        rahmen    | griffe   | Rahmen (normal)  | Rahmen (normal) | Standard°      | Rahmen (normal) | Rahmen (normal) | Standard°
        rahmen    | egal     | Rahmen (normal)  | Rahmen (normal) | Standard°      | Rahmen (normal) | Rahmen (normal) | Standard°
        markant   | grifflos | Iconic           | Iconic          | Iconic         | Iconic          | Iconic          | Iconic
        markant   | griffe   | Liniert          | Liniert         | Standard°      | Rahmen (oval)   | Standard°       | Standard°
        markant   | egal     | Liniert          | Liniert         | Iconic         | Iconic          | Iconic          | Iconic
        (* = mit Hinweis-Zeile, ° = eigene „Warum“-Zeile)
      Kurzfassung (4 Fragen): Charakter = ruhig, Temperatur = offen → grifflos ⇒ Modern, Griffe/egal ⇒ Standard.

   2) Farben = Oberfläche × Helligkeit (Frage 3) × Temperatur (Frage 4) → 3 Musterfarben (Tabelle FARBEN, von Hand
      aus den gemessenen Swatches gewählt; jede Farbe einer Oberfläche gibt es in jedem Style dieser Oberfläche).
      „Bin offen“ mischt warm/neutral/kühl. Holz ist von Natur aus warm – bei „Kühl“ steht Grauholz (der kühlste
      Holzton) vorn und der Text sagt das ehrlich. Eine 4. Farbe in der Liste ist Ersatz. Fehlt eine Farbe in der
      Muster-Kollektion oder ist ihr Gratis-Muster ausverkauft, rückt die nächste nach: erst der Ersatz, dann gleiche
      Helligkeit in der Reihenfolge der Antwort (warm → offen → kühl, kühl → offen → warm, offen → warm → kühl),
      zuletzt die übrigen Farben der Oberfläche.
      Das große Ergebnisfoto zeigt den Style in der ersten der 3 Farben mit Variantenbild ≥ 1080px (scharf am Handy),
      sonst der ersten mit Variantenbild, sonst das Hauptbild.

   3) Warenkorb: die gewählten (Standard: alle 3) Gratis-Varianten 5 × 5 cm plus angetippte „Passt auch“-Farben
      (bis zu 6 weitere derselben Oberfläche: gleiche Helligkeit + passende Temperatur zuerst, Regeln in recommend(),
      je Stufe nach Farbabstand ΔE zu den 3 Farben sortiert, Tabelle LAB) per
      POST /cart/add.js, Zusatzangaben wie auf der Muster-Seite (System · Oberfläche · Größe „5 x 5 cm“), umgekehrte
      Reihenfolge (der Warenkorb zeigt das Letzte oben). Schon liegende Muster werden nicht doppelt gelegt; der Knopf
      zählt nur, was noch fehlt („1 weiteres Gratis-Muster …“), Karten im Warenkorb bleiben gewählt. Danach
      Warenkorb-Attribut „Front-Finder“ (POST /cart/update.js) mit Antworten + Ergebnis, damit die Bestellung es
      trägt (Admin: Bestellung → Zusätzliche Details). Der Drawer öffnet sich über assets/custom.js (fängt
      /cart/add ab); Rückfall nach 1,5 s: window.NFCart.open().

   4) Bilder: alles über das Shopify-CDN mit srcset (w-Deskriptoren) + sizes passend zur gerenderten Größe, nie
      breiter als das Original (Liquid liefert die Originalmaße). Fragen 3/4 zeigen echte Raumfotos: dasselbe Motiv
      in den drei Farben als drei Streifen (Ausschnitt per &crop=region, Tabelle PHOTO). Swatches werden per CDN
      um 8% beschnitten (Rand/Kontur weg) statt per CSS hochskaliert; ist ein Holz-Swatch zu klein, nimmt das Skript
      einen Ausschnitt einer Front aus dem Raumfoto derselben Farbe. Ausnahme Matt Sand (Swatch nur 100px): glatte
      Farbfläche, wird bewusst vergrößert – verliert nichts, das Raumfoto würde den Farbton verfälschen.

   Forschung & Tracking – gesendet wird nur im veröffentlichten Theme (Shopify.theme.role „main“, nicht im
   Theme-Editor) oder zum Testen mit ?ff_track=1:
   - Umfrage: beim Ergebnis EIN anonymer Eintrag je Durchlauf an die NF-App (POST /api/public/umfrage, surveyId
     „front-finder“ bzw. „front-finder-kurz“; Antworten, Ergebnis, Fassung, Gerät, Durchlauf, UTM-Quelle – keine
     E-Mail, kein Name, keine IDs). Neuer Durchlauf = „Nochmal starten“ oder eine geänderte Antwort nach dem Ergebnis
     („Durchlauf“: Erster Durchlauf / Antwort geändert / Nochmal gestartet). Section-Einstellung „Antworten anonym
     speichern“ ist standardmäßig aus – erst einschalten, wenn App-PR #183 live ist.
   - Analytics: ff_start, ff_answer, ff_result (einmal je Durchlauf), ff_add_to_cart (+ ff_cta) als Shopify.analytics.publish (Kunden-
     Ereignisse; Pixel bekommen sie nur mit Einwilligung) und dataLayer.push nur mit Analytics-Einwilligung der
     Shopify Customer Privacy API. Abschaltbar in der Section („Analytics-Ereignisse senden“).
   - Immer (auch in der Vorschau): document-Ereignis „nf:front-finder“ {action, …} für eigene Auswertungen. */
(function () {
  'use strict';

  /* ---------------- Fragen (Texte wörtlich aus der Aufgabe, Du-Form) ---------------- */
  var QUESTIONS = {
    system:      { q: 'Wofür suchst du neue Fronten?', a: [['METOD', 'METOD Küche'], ['PAX', 'PAX Schrank']] },
    oberflaeche: { q: 'Welche Oberfläche fühlt sich nach dir an?', a: [['Matt', 'Matt'], ['Holz Fein', 'Holz fein'], ['Holz Rustikal', 'Holz rustikal']] },
    helligkeit:  { q: 'Eher hell oder dunkel?', a: [['hell', 'Hell & freundlich'], ['mittel', 'Ausgewogen'], ['dunkel', 'Dunkel & edel']] },
    temperatur:  { q: 'Warme oder kühle Töne?', a: [['warm', 'Warm'], ['kühl', 'Kühl'], ['offen', 'Bin offen']] },
    charakter:   { q: 'Wie viel Charakter darf die Front zeigen?', a: [['ruhig', 'Ruhig & zeitlos'], ['rahmen', 'Klassisch mit Rahmen'], ['markant', 'Markant & besonders']] },
    griffe:      { q: 'Griffe – ja oder nein?', a: [['grifflos', 'Grifflos & bündig'], ['griffe', 'Klassische Griffe'], ['egal', 'Egal']] }
  };
  var ORDER_FULL = ['system', 'oberflaeche', 'helligkeit', 'temperatur', 'charakter', 'griffe'];
  /* Anzeigen: Möbel? · Matt/Holz? · hell/dunkel? · grifflos? */
  var ORDER_KURZ = ['system', 'oberflaeche', 'helligkeit', 'griffe'];
  var KURZ_DEFAULTS = { temperatur: 'offen', charakter: 'ruhig' };

  /* ---------------- Styles: Name, Texte, Icon, Konfigurator-Produkt je System/Oberfläche ---------------- */
  var STYLES = {
    'Standard': {
      zusatz: 'Griff nach Wahl', icon: 'simple', markant: false, rahmen: false, grifflos: false,
      warum: 'Glatte Front mit klassischem Griff – zeitlos, ruhig und passt zu fast allem.',
      h: {
        METOD: { 'Matt': 'metod-kuche-front-standard-matt', 'Holz Fein': 'metod-kuche-front-standard-holz-fein', 'Holz Rustikal': 'metod-kuche-front-standard-holz-rustikal' },
        PAX: { 'Matt': 'schrank-fronten-konfigurator-standard-matt', 'Holz Fein': 'schrank-fronten-konfigurator-standard-holz-fein', 'Holz Rustikal': 'schrank-fronten-konfigurator-standard-holz-rustikal' }
      }
    },
    'Rahmen (normal)': {
      zusatz: 'Griff nach Wahl', icon: 'frame', markant: false, rahmen: true, grifflos: false,
      warum: 'Klassischer Rahmen – Landhaus-Charme, modern umgesetzt.',
      h: {
        METOD: { 'Matt': 'metod-kuche-front-rahmen-normal-matt', 'Holz Fein': 'kuchen-fronten-konfigurator-rahmen-normal-holz-fein' },
        PAX: { 'Matt': 'schrank-fronten-konfigurator-rahmen-normal-matt', 'Holz Fein': 'schrank-fronten-konfigurator-rahmen-normal-holz-fein' }
      }
    },
    'Rahmen (schmal)': {
      zusatz: 'Griff nach Wahl', icon: 'fine', markant: false, rahmen: true, grifflos: false,
      warum: 'Schmaler Rahmen – klassisch, aber dezent und modern.',
      h: {
        METOD: { 'Matt': 'metod-kuche-front-rahmen-schmal-matt', 'Holz Fein': 'metod-kuche-front-rahmen-schmal-holz-fein' },
        PAX: { 'Matt': 'schrank-fronten-konfigurator-rahmen-schmal-matt' }
      }
    },
    'Rahmen (oval)': {
      zusatz: 'Griff nach Wahl', icon: 'pool', markant: true, rahmen: true, grifflos: false,
      warum: 'Ovale Kassette – weiche Form, ein echter Hingucker.',
      h: {
        METOD: { 'Matt': 'metod-kuche-front-rahmen-oval-matt' },
        PAX: { 'Matt': 'schrank-fronten-konfigurator-rahmen-oval-matt' }
      }
    },
    'Modern': {
      zusatz: 'inkl. Komplettgriff', icon: 'modern', markant: false, rahmen: false, grifflos: true,
      warum: 'Grifflos dank eingearbeitetem Komplettgriff – klare Linien, ruhige Fläche.',
      h: {
        METOD: { 'Matt': 'metod-kuche-front-modern-inkl-komplettgriff-matt', 'Holz Fein': 'metod-kuche-front-modern-inkl-komplettgriff-holz-fein', 'Holz Rustikal': 'metod-kuche-front-modern-inkl-komplettgriff-holz-rustikal' },
        PAX: { 'Matt': 'schrank-fronten-konfigurator-modern-inkl-komplettgriff-matt', 'Holz Fein': 'schrank-fronten-konfigurator-modern-inkl-komplettgriff-holz-fein', 'Holz Rustikal': 'schrank-fronten-konfigurator-modern-inkl-komplettgriff-holz-rustikal' }
      }
    },
    'Iconic': {
      zusatz: 'bündige Griffmulde mit Holz-Akzent', icon: 'iconic', markant: true, rahmen: false, grifflos: true,
      warum: 'Kein aufgesetzter Griff: Die bündige Griffmulde mit Holz-Akzent ist der Blickfang – schlicht und trotzdem besonders.',
      h: {
        METOD: { 'Matt': 'metod-kuche-front-iconic-inkl-griff-matt', 'Holz Fein': 'metod-kuche-front-iconic-inkl-griff-holz-fein', 'Holz Rustikal': 'metod-kuche-front-iconic-inkl-griff-holz-rusikal' },
        PAX: { 'Matt': 'schrank-fronten-konfigurator-iconic-inkl-griff-matt', 'Holz Fein': 'schrank-fronten-konfigurator-iconic-inkl-griff-holz-fein', 'Holz Rustikal': 'schrank-fronten-konfigurator-iconic-inkl-griff-holz-rusikal' }
      }
    },
    'Liniert': {
      zusatz: 'Griff nach Wahl', icon: 'line', markant: true, rahmen: false, grifflos: false,
      warum: 'Feine Rillen über die ganze Front – lebendige Struktur mit viel Charakter.',
      h: {
        METOD: { 'Matt': 'metod-kuche-front-liniert-matt', 'Holz Fein': 'metod-kuche-front-liniert-holz-fein' },
        PAX: {}
      }
    }
  };

  /* Frage 5 × Frage 6 → Präferenzliste (erster verfügbarer Style gewinnt) */
  var PREF = {
    'ruhig|grifflos':   ['Modern', 'Iconic', 'Standard'],
    'ruhig|griffe':     ['Standard', 'Rahmen (schmal)'],
    'ruhig|egal':       ['Standard', 'Modern'],
    'rahmen|grifflos':  ['Rahmen (schmal)', 'Rahmen (normal)', 'Modern'],
    'rahmen|griffe':    ['Rahmen (normal)', 'Rahmen (schmal)', 'Rahmen (oval)', 'Standard'],
    'rahmen|egal':      ['Rahmen (normal)', 'Rahmen (schmal)', 'Rahmen (oval)', 'Standard'],
    'markant|grifflos': ['Iconic', 'Modern'],
    /* Iconic zuletzt: einziger markanter Style mit sichtbarem Griff, wenn es Liniert/Rahmen (oval) nicht gibt
       (wird dann „Auch passend“ statt des grifflosen Modern) */
    'markant|griffe':   ['Liniert', 'Rahmen (oval)', 'Standard', 'Iconic'],
    'markant|egal':     ['Liniert', 'Iconic', 'Rahmen (oval)', 'Standard']
  };
  var ALT_FALLBACK = ['Modern', 'Iconic', 'Standard'];
  /* „Klassische Griffe“: Alternative nur aus Styles mit aufgesetztem Griff (nie Modern) */
  var ALT_GRIFFE = ['Standard', 'Rahmen (normal)', 'Rahmen (schmal)', 'Liniert', 'Rahmen (oval)'];

  /* Oberfläche × Helligkeit × Temperatur → 3 Musterfarben (Reihenfolge = Priorität, 4. = Ersatz) */
  var FARBEN = {
    'Matt|hell|warm':     ['Beige', 'Cardboard', 'Powder', 'Sand'],
    'Matt|hell|kühl':     ['Minze', 'Wolken', 'Weiß'],
    'Matt|hell|offen':    ['Pearl', 'Beige', 'Minze', 'Sand'],
    'Matt|mittel|warm':   ['Turmeric', 'Powder', 'Salbei'],
    'Matt|mittel|kühl':   ['Blau/Grau', 'Eukaliptus', 'Zement'],
    'Matt|mittel|offen':  ['Eukaliptus', 'Turmeric', 'Zement'],
    'Matt|dunkel|warm':   ['Weinrot', 'Spinach', 'Schwarz', 'Kohle'],
    'Matt|dunkel|kühl':   ['Nachthimmel', 'Wald', 'Meer', 'Kohle'],
    'Matt|dunkel|offen':  ['Nachthimmel', 'Weinrot', 'Schwarz', 'Kohle'],
    'Holz|hell|warm':     ['Natürliche Eiche', 'Weiße Eiche', 'Pekannuss'],
    'Holz|hell|kühl':     ['Grauholz', 'Weiße Eiche', 'Natürliche Eiche'],
    'Holz|hell|offen':    ['Weiße Eiche', 'Natürliche Eiche', 'Pekannuss'],
    'Holz|mittel|warm':   ['Pekannuss', 'Natürliche Eiche', 'Kastanie Braun'],
    'Holz|mittel|kühl':   ['Grauholz', 'Weiße Eiche', 'Schwarze Eiche'],
    'Holz|mittel|offen':  ['Pekannuss', 'Grauholz', 'Natürliche Eiche'],
    'Holz|dunkel|warm':   ['Kastanie Braun', 'Schwarze Eiche', 'Pekannuss'],
    'Holz|dunkel|kühl':   ['Schwarze Eiche', 'Grauholz', 'Kastanie Braun'],
    'Holz|dunkel|offen':  ['Schwarze Eiche', 'Kastanie Braun', 'Grauholz']
  };
  /* Holz Fein und Holz Rustikal haben dieselben 6 Namen → eine Tabelle „Holz“ für beide */
  function farbKey(fin, hell, temp) { return (fin === 'Matt' ? 'Matt' : 'Holz') + '|' + hell + '|' + temp; }

  /* Bildmotive der Fragen */
  var VIS = {
    system: { METOD: 'metod-kuche-front-standard-holz-fein', PAX: 'schrank-fronten-konfigurator-modern-inkl-komplettgriff-matt' },
    oberflaeche: {
      'Matt': ['Beige', 'Salbei', 'Meer', 'Nachthimmel'],
      'Holz Fein': ['Natürliche Eiche', 'Weiße Eiche', 'Kastanie Braun', 'Grauholz'],
      'Holz Rustikal': ['Natürliche Eiche', 'Weiße Eiche', 'Kastanie Braun', 'Grauholz']
    },
    /* Frage 5: „Markant“ zeigt den ersten markanten Style, den es für System + Oberfläche gibt (CHAR_MARKANT) */
    charakter: { ruhig: ['simple'], rahmen: ['frame'] },
    /* „Grifflos & bündig“ nur mit der grifflosen Modern-Front – das Iconic-Icon zeigt die Holz-Griffmulde wie einen Griff */
    griffe: { grifflos: ['modern'], griffe: ['simple+handle'], egal: ['modern', 'simple+handle'] }
  };
  var CHAR_MARKANT = ['Liniert', 'Rahmen (oval)', 'Iconic'];
  /* Bilder einer Frage hängen von diesen früheren Antworten ab (fürs Vorladen) */
  var DEPENDS = { helligkeit: ['system', 'oberflaeche'], temperatur: ['system', 'oberflaeche', 'helligkeit'], charakter: ['system', 'oberflaeche'] };

  /* Fragen 3/4: Raumfotos (Variantenbilder) je System + Oberfläche – alle Farben eines Produkts zeigen dasselbe Motiv,
     deshalb ergeben drei Streifen aus drei Farben ein durchgehendes Bild. crop = [links, oben, Breite] als Anteil der
     Bildbreite (quadratischer Ausschnitt, Streifen = je ein Drittel), door = quadratischer Ausschnitt einer
     Frontfläche (Ersatz, wenn ein Swatch zu klein ist). Reihenfolge = Vorrang; das erste Produkt mit allen drei Farben
     gewinnt (PAX Standard Matt hat kein Weiß/Schwarz/Weinrot → PAX Modern Matt zuerst). Holz: zuerst das Produkt,
     dessen Variantenbilder die Farben unterscheidbar zeigen (gemessen 05.10.2026, Frontfläche gegen Muster): PAX Modern
     statt Standard (dort sieht Weiße Eiche aus wie Natürliche Eiche, Grauholz fast schwarz), METOD Iconic statt Modern
     (Modern: Weiße ≈ Natürliche Eiche, Rustikal Pekannuss ≈ Kastanie). METOD Iconic Holz Fein hat kein Kastanie Braun –
     Kacheln mit Kastanie nehmen dann über „erstes Produkt mit allen 3 Farben“ METOD Modern. */
  var CROP_METOD_MATT = { crop: [0.585, 0.08, 0.415], door: [0.64, 0.15, 0.15] };
  var CROP_METOD_UNTEN = { crop: [0, 0.43, 0.5], door: [0.06, 0.5, 0.18] };
  var CROP_PAX = { crop: [0.13, 0.05, 0.74], door: [0.36, 0.15, 0.28] };
  function ph(h, c) { return { h: h, crop: c.crop, door: c.door }; }
  var PHOTO = {
    'METOD|Matt': [ph('metod-kuche-front-standard-matt', CROP_METOD_MATT), ph('metod-kuche-front-modern-inkl-komplettgriff-matt', CROP_METOD_UNTEN)],
    'METOD|Holz Fein': [ph('metod-kuche-front-iconic-inkl-griff-holz-fein', CROP_METOD_UNTEN), ph('metod-kuche-front-modern-inkl-komplettgriff-holz-fein', CROP_METOD_UNTEN)],
    'METOD|Holz Rustikal': [ph('metod-kuche-front-iconic-inkl-griff-holz-rusikal', CROP_METOD_UNTEN), ph('metod-kuche-front-modern-inkl-komplettgriff-holz-rustikal', CROP_METOD_UNTEN)],
    'PAX|Matt': [ph('schrank-fronten-konfigurator-modern-inkl-komplettgriff-matt', CROP_PAX), ph('schrank-fronten-konfigurator-standard-matt', CROP_PAX)],
    'PAX|Holz Fein': [ph('schrank-fronten-konfigurator-modern-inkl-komplettgriff-holz-fein', CROP_PAX), ph('schrank-fronten-konfigurator-standard-holz-fein', CROP_PAX)],
    'PAX|Holz Rustikal': [ph('schrank-fronten-konfigurator-modern-inkl-komplettgriff-holz-rustikal', CROP_PAX), ph('schrank-fronten-konfigurator-standard-holz-rustikal', CROP_PAX)]
  };

  /* „Passt auch“: CIELAB der Swatches (Mittelwert der mittleren 60%, D65; gemessen 05.10.2026, quiz-data.json) */
  var LAB = {
    'Matt': { 'Sand': [87.7, -1.1, 5.1], 'Wolken': [80.6, -0.4, 3.2], 'Cardboard': [85.5, 0.2, 6.2], 'Pearl': [87.5, 0.3, 2.3], 'Powder': [72.3, 10.8, 8.6], 'Beige': [90.5, -0.2, 12], 'Turmeric': [66.8, 3.8, 20.5], 'Wald': [28.8, -7.1, 1.7], 'Spinach': [41.5, -2.8, 6.7], 'Blau/Grau': [51.6, -5.6, -2.5], 'Zement': [65.7, -4.3, -0.3], 'Eukaliptus': [56.9, -5.5, 4.8], 'Kohle': [36.2, -1.8, 0], 'Meer': [46.8, -4.9, -9.8], 'Nachthimmel': [26.5, -0.1, -5.6], 'Minze': [75.2, -9.8, 9.8], 'Salbei': [74.3, -3.6, 9], 'Weiß': [100, 0, 0], 'Schwarz': [12.7, -0.2, 0.7], 'Weinrot': [18.6, 22.4, 16.8] },
    'Holz Fein': { 'Schwarze Eiche': [13.4, 1, 6.7], 'Kastanie Braun': [26.8, 13.7, 19.1], 'Grauholz': [60.8, 1.5, 6], 'Natürliche Eiche': [60.7, 7.3, 38.2], 'Pekannuss': [58.1, 4.3, 29.3], 'Weiße Eiche': [71.9, 2.8, 13.5] },
    'Holz Rustikal': { 'Schwarze Eiche': [13.6, 0.8, 1.8], 'Kastanie Braun': [22.6, 15, 17.2], 'Grauholz': [45.1, -0.2, 3], 'Natürliche Eiche': [67.6, 12.1, 37.5], 'Pekannuss': [54.3, 7.3, 13.5], 'Weiße Eiche': [75.7, 6.6, 24.6] }
  };
  var MORE_MAX = 6;
  /* „Passt auch“ bei Matt: Nachbar-Helligkeit (nur bis ΔL* 15 zur nächsten der 3 Farben) */
  var HELL_NEIGHBOR = { hell: ['mittel'], mittel: ['hell', 'dunkel'], dunkel: ['mittel'] };

  /* Variantenbilder im Shop, die eine andere Farbe zeigen (gemessen 05.10.2026: Frontfläche im Foto gegen Muster;
     das Foto gleicht einer anderen Farbe desselben Produkts). Diese Karten nehmen das Foto aus PHOTO oder den Swatch.
     Bis die Bilder im Shop korrigiert sind – der Konfigurator zeigt dieselben falschen Bilder. */
  var BAD_PHOTO = {
    'metod-kuche-front-standard-holz-fein': ['Weiße Eiche', 'Pekannuss'],
    'metod-kuche-front-modern-inkl-komplettgriff-holz-fein': ['Weiße Eiche'],
    'metod-kuche-front-rahmen-schmal-holz-fein': ['Pekannuss'],
    'metod-kuche-front-modern-inkl-komplettgriff-holz-rustikal': ['Pekannuss'],
    'schrank-fronten-konfigurator-standard-holz-fein': ['Weiße Eiche'],
    'schrank-fronten-konfigurator-standard-holz-rustikal': ['Weiße Eiche'],
    'schrank-fronten-konfigurator-iconic-inkl-griff-holz-rusikal': ['Pekannuss', 'Weiße Eiche']
  };

  /* Frage 2: Unterzeile = Haptik (Wortlaut wie Material-Seite) + Anzahl */
  var FIN_SUB = { 'Matt': 'glatte Fläche', 'Holz Fein': 'feine Maserung', 'Holz Rustikal': '3D-Struktur' };
  /* was bei der Oberfläche den Charakter bringt (für „Warum“-Zeilen ohne passenden Style) */
  var FIN_CHAR = { 'Matt': 'die Farbe', 'Holz Fein': 'die feine Holzmaserung', 'Holz Rustikal': 'die 3D-Struktur in Brett-Optik' };

  var TXT = {
    hell: { hell: 'Hell & freundlich', mittel: 'Ausgewogen', dunkel: 'Dunkel & edel' },
    temp: { warm: ' mit warmem Unterton', 'kühl': ' mit kühlem Unterton', offen: ', von warm bis kühl' },
    /* Holz hat keinen kühlen Ton – ehrlich sagen statt „mit kühlem Unterton“ */
    tempHolz: { warm: ' mit warmem Unterton', 'kühl': ' und möglichst kühl – Grauholz ist unser kühlster Holzton.', offen: ', von warm bis neutral' },
    systemFor: { METOD: 'für deine METOD Küche', PAX: 'für deinen PAX Schrank' }
  };
  /* Nachrücken, wenn eine Farbe fehlt: Temperaturen in der Reihenfolge der Antwort */
  var TEMP_ORDER = { warm: ['warm', 'offen', 'kühl'], 'kühl': ['kühl', 'offen', 'warm'], offen: ['offen', 'warm', 'kühl'] };

  var STORE_KEY = 'nf-ff-v1';
  var STORE_MAX_AGE = 30 * 60 * 1000;

  /* ---------------- Hilfen ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Shopify-CDN: Breite per &width=, Ausschnitt per &crop=region (Pixel des Originals). Das CDN vergrößert nie –
     größer als das Original anfragen bringt nichts. */
  function cdn(url, w, crop) {
    var u = String(url || '').replace(/([?&])width=\d+(&|$)/, function (m, a, b) { return b ? a : ''; });
    var q = [];
    if (crop) q.push('crop=region', 'crop_left=' + crop[0], 'crop_top=' + crop[1], 'crop_width=' + crop[2], 'crop_height=' + crop[3]);
    if (w) q.push('width=' + w);
    return q.length ? u + (u.indexOf('?') === -1 ? '?' : '&') + q.join('&') : u;
  }
  /* Bildbreiten (CSS-Pixel × Pixeldichte 1–3) und sizes je Platz im Layout (Handy: Rand 2 × 16px; ab 750px fest) */
  var W_SLICE = [40, 60, 80, 100, 120, 160, 220];
  var W_SWATCH = [60, 90, 120, 160, 200, 240, 320, 400, 480];
  var W_ICON = [100, 150, 200, 300, 400, 600];
  var W_MID = [120, 180, 240, 320, 400, 480, 600, 720, 900];
  var W_BIG = [360, 540, 720, 900, 1080, 1440, 1800];
  var SZ = {
    opt3: '(min-width: 750px) 223px, calc((100vw - 95px) / 3)',
    slice: '(min-width: 750px) 73px, calc((100vw - 107px) / 9)',
    cell: '(min-width: 750px) 110px, calc((100vw - 104px) / 6)',
    opt2: '(min-width: 750px) 282px, calc((100vw - 64px) / 2)',
    icon: '(min-width: 750px) 206px, calc((100vw - 95px) * 0.31)',
    iconAlt: '56px',
    hero: '(min-width: 900px) 516px, (min-width: 750px) calc((100vw - 60px) / 2), calc(100vw - 32px)',
    card: '(min-width: 900px) 159px, (min-width: 750px) calc((100vw - 60px) / 6 - 10px), calc((100vw - 60px) / 3)',
    chip: '(min-width: 900px) 48px, (min-width: 750px) calc((100vw - 60px) / 20), calc((100vw - 60px) / 10)',
    more: '64px'
  };
  /* srcset mit w-Deskriptoren, gekappt auf die Originalbreite (nat) */
  function picSet(url, o) {
    var nat = o.nat || 0, max = o.ws[o.ws.length - 1];
    var ws = o.ws.filter(function (w) { return !nat || w < nat; });
    if (nat && nat < max) ws.push(nat);
    if (!ws.length) ws = [o.ws[0]];
    return {
      src: cdn(url, ws[Math.min(2, ws.length - 1)], o.crop),
      srcset: ws.map(function (w) { return cdn(url, w, o.crop) + ' ' + w + 'w'; }).join(', '),
      sizes: o.sizes
    };
  }
  function pic(url, o) {
    if (!url) return '';
    var p = picSet(url, o);
    return '<img' + (o.cls ? ' class="' + o.cls + '"' : '') + ' src="' + esc(p.src) + '" srcset="' + esc(p.srcset) + '" sizes="' + esc(p.sizes) + '" alt="' + esc(o.alt || '') + '" decoding="async">';
  }
  /* Bild vorab laden – dieselben src/srcset/sizes wie pic(), damit der Browser dieselbe Datei nimmt */
  var preloaded = {};
  function preload(url, o) {
    if (!url) return;
    var p = picSet(url, o);
    if (preloaded[p.srcset]) return;
    preloaded[p.srcset] = true;
    try { var im = new Image(); im.decoding = 'async'; im.sizes = p.sizes; im.srcset = p.srcset; im.src = p.src; } catch (e) {}
  }
  /* Swatch-Ausschnitt ohne Rand: 8% je Seite (Konturen, runde Ecken), Swatches sind quadratisch */
  function swatchCrop(s) {
    var n = s && s.iw;
    if (!n) return null;
    var m = Math.round(n * 0.08);
    return [m, m, n - 2 * m, n - 2 * m];
  }
  function newRun() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function quote(s) { return '„' + s + '“'; }
  function price(cents) { return (cents / 100).toFixed(2).replace('.', ',') + '€'; }
  function reduceMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  var ICON_CHECK = '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" focusable="false"><path d="m4.5 10.5 3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_BACK = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><path d="M7.5 4.5 13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_INFO = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="7.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M10 9v4.5M10 6.4v.1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" focusable="false"><path d="M10 4.5v11M4.5 10h11" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var ICON_GIFT = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M3.5 8h13v2.5h-13zM4.5 10.5h11V17h-11zM10 8v9M10 8c-1.6-2.6-4.6-3.2-4.6-1.2 0 1.2 2.4 1.2 4.6 1.2zm0 0c1.6-2.6 4.6-3.2 4.6-1.2 0 1.2-2.4 1.2-4.6 1.2z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  var ICON_RESTART = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><path d="M4.5 10a5.5 5.5 0 1 0 1.7-4M4.5 3.5V7H8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init(root) {
    if (root.__nfff) return;
    root.__nfff = true;

    var data;
    try { data = JSON.parse(root.querySelector('[data-ff-data]').textContent); } catch (e) { return; }
    var cfg = data.cfg || {};
    var products = data.products || {};
    var icons = data.icons || {};
    var samples = (data.samples || []).filter(function (s) { return s && s.id && s.n && s.f; });

    var qs = {};
    try { qs = Object.fromEntries(new URLSearchParams(location.search)); } catch (e) {}
    var kurz = qs.kurz === '1' ? true : qs.kurz === '0' ? false : !!cfg.kurz;
    var mode = kurz ? 'kurz' : 'voll';
    var order = kurz ? ORDER_KURZ : ORDER_FULL;
    var total = order.length;

    var stage = root.querySelector('[data-ff-stage]');
    var intro = root.querySelector('[data-ff-intro]');
    var live = root.querySelector('[data-ff-live]');

    /* Bilder: dasselbe Foto für zwei Farben = Datenfehler im Shop (z. B. METOD Standard Holz Rustikal: Schwarze
       und Weiße Eiche zeigen dasselbe Bild) → für beide lieber den Swatch zeigen */
    Object.keys(products).forEach(function (h) {
      var c = products[h].c || {}, seen = {};
      Object.keys(c).forEach(function (n) { var k = String(c[n]).replace(/[?&]width=\d+/, ''); seen[k] = (seen[k] || 0) + 1; });
      Object.keys(c).forEach(function (n) { var k = String(c[n]).replace(/[?&]width=\d+/, ''); if (seen[k] > 1) delete c[n]; });
    });
    /* … und Fotos, die sichtbar die falsche Farbe zeigen (BAD_PHOTO) */
    Object.keys(BAD_PHOTO).forEach(function (h) {
      var c = products[h] && products[h].c;
      if (c) BAD_PHOTO[h].forEach(function (n) { delete c[n]; });
    });

    /* Helligkeit(en) und Temperatur einer Farbe aus den FARBEN-Listen ihrer Oberfläche: warm = steht nur in warm-Listen,
       kuehl = nur in kühl-Listen, beides/keins = neutral. Eine Farbe, die in keiner Liste steht, kommt nie in „Passt auch“. */
    var farbInfoCache = {};
    function farbInfo(fin) {
      var base = fin === 'Matt' ? 'Matt' : 'Holz';
      if (farbInfoCache[base]) return farbInfoCache[base];
      var info = {};
      Object.keys(FARBEN).forEach(function (k) {
        var p = k.split('|');
        if (p[0] !== base) return;
        FARBEN[k].forEach(function (n) {
          var x = info[n] || (info[n] = { hell: {}, warm: false, kuehl: false });
          x.hell[p[1]] = true;
          if (p[2] === 'warm') x.warm = true;
          if (p[2] === 'kühl') x.kuehl = true;
        });
      });
      return (farbInfoCache[base] = info);
    }
    function sample(fin, name) {
      for (var i = 0; i < samples.length; i++) if (samples[i].f === fin && samples[i].n === name) return samples[i];
      return null;
    }
    function finishCount(fin) { return samples.filter(function (s) { return s.f === fin; }).length; }
    function styleHandle(style, sys, fin) {
      var h = STYLES[style] && STYLES[style].h[sys] && STYLES[style].h[sys][fin];
      return h && products[h] ? h : null;
    }
    function available(style, sys, fin) { return !!styleHandle(style, sys, fin); }

    /* ---------------- Fotos & Swatches ---------------- */
    /* erstes Foto-Produkt (PHOTO) mit einem Variantenbild in dieser Farbe → { url, w, h, e } */
    function photoOf(sys, fin, name) {
      var list = PHOTO[sys + '|' + fin] || [];
      for (var i = 0; i < list.length; i++) {
        var pr = products[list[i].h];
        if (pr && pr.c && pr.c[name] && pr.d && pr.d[name]) return { url: pr.c[name], w: pr.d[name][0], h: pr.d[name][1], e: list[i] };
      }
      return null;
    }
    /* Ausschnitt in Pixeln: r = [links, oben, Breite] als Anteil der Bildbreite, Höhe = Breite × aspect */
    function region(p, r, aspect) {
      var l = Math.round(r[0] * p.w), t = Math.round(r[1] * p.h);
      var cw = Math.min(Math.round(r[2] * p.w), p.w - l), ch = Math.min(Math.round(r[2] * p.w * (aspect || 1)), p.h - t);
      return [l, t, cw, ch];
    }
    /* Swatch scharf: per CDN beschnitten. Reicht ein Holz-Swatch für need CSS-Pixel × 3 nicht, eine Frontfläche aus dem
       Raumfoto derselben Farbe (Maserung bleibt scharf). Matt bleibt immer beim Swatch: eine glatte Farbfläche verliert
       beim Vergrößern nichts (Sand hat nur 100px), das Raumfoto würde die Farbe durch Licht und Schatten verfälschen. */
    function swatchPic(s, sizes, need, sys) {
      if (!s) return '';
      var crop = swatchCrop(s);
      if ((!crop || crop[2] < need * 3) && sys && s.f !== 'Matt') {
        var p = photoOf(sys, s.f, s.n);
        if (p && p.e.door) {
          var r = region(p, p.e.door, 1);
          if (r[2] > (crop ? crop[2] : 0)) return pic(p.url, { ws: W_SWATCH, sizes: sizes, nat: r[2], crop: r });
        }
      }
      return pic(s.img, { ws: W_SWATCH, sizes: sizes, nat: crop ? crop[2] : 0, crop: crop });
    }
    /* Fragen 3/4: drei Farben als drei Streifen desselben Raumfotos */
    function photoTile(sys, fin, names) {
      names = names.slice(0, 3);
      var list = PHOTO[sys + '|' + fin] || [];
      var whole = list.filter(function (e) {
        var pr = products[e.h];
        return pr && pr.c && pr.d && names.every(function (n) { return pr.c[n] && pr.d[n]; });
      })[0];
      var out = names.map(function (n, i) {
        var p = null;
        if (whole) { var pr = products[whole.h]; p = { url: pr.c[n], w: pr.d[n][0], h: pr.d[n][1], e: whole }; }
        else p = photoOf(sys, fin, n);
        if (p) {
          var c = p.e.crop, third = c[2] / 3;
          var r = region(p, [c[0] + i * third, c[1], third], 3);
          return '<span class="nf-ff__slice">' + pic(p.url, { ws: W_SLICE, sizes: SZ.slice, nat: r[2], crop: r }) + '</span>';
        }
        /* kein Foto in dieser Farbe: Swatch füllt den Streifen (wird auf Kachelhöhe skaliert) */
        return '<span class="nf-ff__slice">' + swatchPic(sample(fin, n), SZ.opt3, 0) + '</span>';
      });
      return '<span class="nf-ff__vis nf-ff__vis--slices">' + out.join('') + '</span>';
    }

    /* ---------------- Zustand ---------------- */
    /* run = Durchlauf (für genau einen Umfrage-Eintrag), sent = run, dessen Eintrag schon gesendet ist,
       tracked = run, dessen Ergebnis schon gezählt ist (ff_result einmal je Durchlauf), kind = Art des Durchlaufs
       (erster / Antwort geändert / nochmal gestartet – für die Auswertung) */
    var state = { view: 'intro', step: 0, ans: {}, edit: false, run: newRun(), sent: '', tracked: '', kind: 'erster' };
    var pickedColors = null; /* Auswahl im Ergebnis (Muster an/aus) */
    var pickedMore = {};     /* „Passt auch“: Name → angetippt */
    var prevAns = null;      /* Antworten vor „Nochmal starten“ (nur für Browser-Zurück) … */
    var prevRun = null;      /* … und deren Durchlauf (run/sent/tracked/kind), damit Zurück nichts doppelt sendet */
    var cartDone = false;    /* alle gewählten Muster liegen im Warenkorb (aus updateCartButton) */
    var busy = false;
    /* Varianten-ID → liegt im Warenkorb (Stand aus /cart.js bzw. nach dem Hinzufügen); nur Muster-Varianten */
    var inCart = {};
    var sampleIds = {};
    samples.forEach(function (s) { sampleIds[s.id] = true; });

    function save() {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ t: Date.now(), mode: mode, view: state.view, step: state.step, ans: state.ans, run: state.run, sent: state.sent, tracked: state.tracked, kind: state.kind })); } catch (e) {}
    }
    function load() {
      try {
        var s = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
        if (!s || s.mode !== mode || Date.now() - s.t > STORE_MAX_AGE) return null;
        return s;
      } catch (e) { return null; }
    }
    function clearStore() { try { sessionStorage.removeItem(STORE_KEY); } catch (e) {} }

    /* ---------------- Forschung & Tracking ---------------- */
    /* nur im veröffentlichten Theme (nicht im Editor, nicht in der Vorschau) – oder zum Testen mit ?ff_track=1 */
    var canSend = (function () {
      if (qs.ff_track === '0' || cfg.design) return false;
      if (qs.ff_track === '1') return true;
      var sh = window.Shopify || {};
      return !sh.designMode && !!(sh.theme && sh.theme.role === 'main');
    })();
    var EVENT = { start: 'ff_start', answer: 'ff_answer', result: 'ff_result', cart: 'ff_add_to_cart', cta: 'ff_cta' };
    /* Analytics-Einwilligung aus der Shopify Customer Privacy API; ohne API = keine Einwilligung */
    function analyticsAllowed() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
      } catch (e) { return false; }
    }
    function track(action, extra) {
      var detail = { action: action, mode: mode };
      if (extra) Object.keys(extra).forEach(function (k) { detail[k] = extra[k]; });
      try { document.dispatchEvent(new CustomEvent('nf:front-finder', { detail: detail })); } catch (e) {}
      if (!canSend || cfg.track === false) return;
      var name = EVENT[action] || 'ff_' + action;
      var data = {};
      Object.keys(detail).forEach(function (k) { if (k !== 'action') data[k] = detail[k]; });
      /* Shopify-Kundenereignis: erreicht Pixel nur, wenn deren Einwilligung vorliegt (regelt Shopify) */
      try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
      /* dataLayer (Google/Meta über Tag-Manager) nur mit Analytics-Einwilligung */
      if (!analyticsAllowed()) return;
      try {
        var push = { event: name };
        Object.keys(data).forEach(function (k) { push['ff_' + k] = data[k]; });
        (window.dataLayer = window.dataLayer || []).push(push);
      } catch (e) {}
    }

    /* Umfrage-Eintrag (anonym): Format der NF-App (src/lib/surveys/validate.ts) – je Frage key/label/type/value */
    function utm(name) {
      var v = qs[name];
      if (!v || /@/.test(v)) return '';
      return String(v).toLowerCase().replace(/[^a-z0-9._-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
    }
    function isMobile() {
      try { return window.matchMedia('(max-width: 749px)').matches; } catch (e) { return window.innerWidth < 750; }
    }
    function surveyPayload(rec) {
      var list = order.map(function (id) {
        return { key: id, label: QUESTIONS[id].q, type: 'choice', value: label(id, state.ans[id]) };
      });
      list.push({ key: 'ergebnis_style', label: 'Ergebnis: Style', type: 'choice', value: rec.style });
      list.push({ key: 'ergebnis_farben', label: 'Ergebnis: 3 Farben', type: 'multi', value: rec.colors.map(function (s) { return s.n; }) });
      list.push({ key: 'ergebnis_ersatz', label: 'Ergebnis: Ersatz-Style (Wunsch so nicht lieferbar)', type: 'choice', value: rec.why || rec.hint ? 'ja' : 'nein' });
      if (rec.alt) list.push({ key: 'ergebnis_alternative', label: 'Ergebnis: Auch passend', type: 'choice', value: rec.alt });
      list.push({ key: 'kontext_fassung', label: 'Fassung', type: 'choice', value: kurz ? 'Kurzfassung (4 Fragen)' : 'Volle Fassung (6 Fragen)' });
      list.push({ key: 'kontext_geraet', label: 'Gerät', type: 'choice', value: isMobile() ? 'mobil' : 'desktop' });
      /* damit die Auswertung erste Durchläufe von Herumprobieren trennen kann */
      list.push({ key: 'kontext_durchlauf', label: 'Durchlauf', type: 'choice', value: KIND[state.kind] || KIND.erster });
      [['utm_source', 'UTM-Quelle'], ['utm_medium', 'UTM-Medium'], ['utm_campaign', 'UTM-Kampagne']].forEach(function (u) {
        var v = utm(u[0]);
        if (v) list.push({ key: 'kontext_' + u[0], label: u[1], type: 'choice', value: v });
      });
      return {
        surveyId: kurz ? 'front-finder-kurz' : 'front-finder',
        surveyTitle: kurz ? 'Front-Finder (Kurzfassung)' : 'Front-Finder',
        answers: list,
        pageUrl: location.origin + location.pathname,
        website: ''
      };
    }
    var KIND = { erster: 'Erster Durchlauf', 'geändert': 'Antwort geändert', neu: 'Nochmal gestartet' };
    /* genau ein Eintrag je Durchlauf; text/plain = einfache CORS-Anfrage ohne Preflight, keepalive übersteht Seitenwechsel */
    function sendSurvey(rec) {
      if (!canSend || cfg.umfrage === false || !cfg.endpoint || !rec || !rec.style) return;
      if (state.sent === state.run) return;
      state.sent = state.run;
      save();
      try {
        fetch(cfg.endpoint, {
          method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(surveyPayload(rec))
        }).catch(function () {});
      } catch (e) {}
    }

    function answers() {
      var a = {};
      Object.keys(state.ans).forEach(function (k) { a[k] = state.ans[k]; });
      if (kurz) Object.keys(KURZ_DEFAULTS).forEach(function (k) { if (!a[k]) a[k] = KURZ_DEFAULTS[k]; });
      return a;
    }
    function complete() { return order.every(function (id) { return !!state.ans[id]; }); }
    /* Index der ersten unbeantworteten Frage, -1 = alles beantwortet */
    function firstOpen() {
      for (var i = 0; i < order.length; i++) if (!state.ans[order[i]]) return i;
      return -1;
    }
    function label(id, val) {
      var a = QUESTIONS[id].a;
      for (var i = 0; i < a.length; i++) if (a[i][0] === val) return a[i][1];
      return val;
    }

    /* ---------------- Empfehlung ---------------- */
    function recommend(a) {
      var sys = a.system, fin = a.oberflaeche;
      var list = (PREF[a.charakter + '|' + a.griffe] || []).filter(function (s) { return available(s, sys, fin); });
      var style = list[0];
      if (!style) style = ['Standard', 'Modern', 'Iconic'].filter(function (s) { return available(s, sys, fin); })[0];
      if (!style) style = Object.keys(STYLES).filter(function (s) { return available(s, sys, fin); })[0];
      var alt = list[1] || null;
      if (a.charakter === 'rahmen' && a.griffe === 'grifflos' && style && STYLES[style].rahmen && available('Modern', sys, fin)) alt = 'Modern';
      if (!alt) alt = (a.griffe === 'griffe' ? ALT_GRIFFE : ALT_FALLBACK).filter(function (s) { return s !== style && available(s, sys, fin); })[0] || null;

      /* Wunsch nicht erfüllbar: die „Warum“-Zeile greift ihn auf (why); nur „Rahmen + grifflos“ behält die Hinweis-Zeile */
      var hint = '', why = '';
      var st = STYLES[style] || {};
      var charOf = FIN_CHAR[fin] || 'die Oberfläche';
      if (a.charakter === 'rahmen' && !st.rahmen) {
        why = 'Rahmen gibt es in ' + fin + ' nicht – ' +
          (st.grifflos ? 'grifflos passt ' + (style === 'Modern' ? 'Modern mit Komplettgriff' : style) + ' am besten.' : 'am nächsten kommt die glatte Front mit klassischem Griff.') +
          ' Den Charakter bringt hier ' + charOf + '.';
      } else if (a.griffe === 'grifflos' && st.rahmen) {
        hint = 'Rahmen-Fronten gibt es nur mit Griff' + (style === 'Rahmen (schmal)' ? ' – der schmale Rahmen wirkt am ruhigsten' : '') + '. Grifflos wäre „Modern“ die Alternative.';
      } else if (a.charakter === 'markant' && !st.markant) {
        why = fin === 'Holz Rustikal'
          ? 'Bei Holz Rustikal bringt die 3D-Struktur in Brett-Optik den markanten Look – die glatte Front mit klassischem Griff lässt sie wirken.'
          : 'Liniert und Rahmen (oval) gibt es für ' + sys + ' in ' + fin + ' nicht – die glatte Front mit klassischem Griff lässt ' + charOf + ' wirken.';
      }

      /* Farben: Liste (3 + Ersatz), dann gleiche Helligkeit in der Temperatur-Reihenfolge der Antwort, dann alle */
      var names = (FARBEN[farbKey(fin, a.helligkeit, a.temperatur)] || []).slice();
      var colors = [];
      function take(n) {
        if (colors.length >= 3) return;
        var s = sample(fin, n);
        if (s && s.a !== false && colors.indexOf(s) === -1) colors.push(s);
      }
      names.forEach(take);
      if (colors.length < 3) (TEMP_ORDER[a.temperatur] || TEMP_ORDER.offen).forEach(function (t) { (FARBEN[farbKey(fin, a.helligkeit, t)] || []).forEach(take); });
      if (colors.length < 3) samples.forEach(function (s) { if (s.f === fin) take(s.n); });

      var handle = styleHandle(style, sys, fin);
      var product = handle ? products[handle] : null;
      /* großes Foto: der Style in der ersten empfohlenen Farbe, die ein eigenes Variantenbild hat */
      /* großes Foto: der Style in einer der 3 Farben – bevorzugt eine mit scharfem Bild (≥ 1080px, Handy dpr 3),
         sonst die erste mit Variantenbild, sonst das Hauptbild */
      var heroUrl = '', heroColor = '', heroNat = 0;
      if (product) {
        [1080, 0].forEach(function (minW) {
          for (var i = 0; i < colors.length && !heroUrl; i++) {
            var n = colors[i].n, w = product.d && product.d[n] ? product.d[n][0] : 0;
            if (product.c && product.c[n] && w >= minW) { heroUrl = product.c[n]; heroColor = n; heroNat = w; }
          }
        });
        if (!heroUrl) { heroUrl = product.hero || ''; heroNat = product.hw || 0; }
      }

      /* „Passt auch“: weitere Farben, die zu Helligkeit + Temperatur passen (nicht einfach alle Farben der Oberfläche).
         Helligkeit und Temperatur einer Farbe ergeben sich aus den FARBEN-Listen (farbInfo). Reihenfolge:
         1) gleiche Helligkeit, Temperatur passt (bei „offen“ alle; neutrale Farben passen immer)
         2) nur Matt (Holz hat je Helligkeit schon alle Töne): Nachbar-Helligkeit, Temperatur passt, höchstens
            ΔL* 15 von der nächsten der 3 Farben
         3) gleiche Helligkeit, Gegen-Temperatur
         Innerhalb jeder Stufe nach Farbabstand ΔE76 zu den 3 Farben; die Reihe ist deshalb oft kürzer als 6. */
      var lab = LAB[fin] || {};
      function de(x, y) { return x && y ? Math.sqrt(Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2)) : 999; }
      function near(s) { return Math.min.apply(null, colors.map(function (c) { return de(lab[s.n], lab[c.n]); })); }
      function dL(s) { return Math.min.apply(null, colors.map(function (c) { return lab[s.n] && lab[c.n] ? Math.abs(lab[s.n][0] - lab[c.n][0]) : 999; })); }
      var info = farbInfo(fin), temp = a.temperatur, hell = a.helligkeit;
      function tempFits(x) { return temp === 'warm' ? !(x.kuehl && !x.warm) : temp === 'kühl' ? !(x.warm && !x.kuehl) : true; }
      var tiers = [[], [], []];
      samples.forEach(function (s) {
        var x = info[s.n];
        if (!x || s.f !== fin || s.a === false || colors.indexOf(s) !== -1) return;
        if (x.hell[hell]) tiers[tempFits(x) ? 0 : 2].push(s);
        else if (fin === 'Matt' && tempFits(x) && (HELL_NEIGHBOR[hell] || []).some(function (h) { return x.hell[h]; }) && dL(s) <= 15) tiers[1].push(s);
      });
      var more = tiers.reduce(function (acc, t) { return acc.concat(t.sort(function (x, y) { return near(x) - near(y); })); }, []).slice(0, MORE_MAX);

      return { style: style, alt: alt, hint: hint, why: why, colors: colors, more: more, handle: handle, product: product, heroUrl: heroUrl, heroColor: heroColor, heroNat: heroNat };
    }

    /* ---------------- Ansichten ---------------- */
    function announce(text) {
      if (!live) return;
      live.textContent = '';
      setTimeout(function () { live.textContent = text; }, 60);
    }

    /* Fragen: nur wenn der Quiz-Anfang nicht im Bild ist; Ergebnis: immer an den Anfang (unter den festen Kopf), damit
       Foto, Farben und Knopf möglichst ohne Scrollen zu sehen sind */
    function scrollToTop(force) {
      var r = root.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6 || (force && r.top > 100)) {
        var y = window.pageYOffset + r.top - 90;
        try { window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion() ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
      }
    }

    function show(view, step, opts) {
      opts = opts || {};
      /* Schutz: Ergebnis nur mit allen Antworten, Fragen nie hinter der ersten offenen (z. B. Browser-Zurück nach
         „Nochmal starten“ oder ein alter Stand aus der Sitzung) */
      var fo = firstOpen(), redirected = false;
      if (view === 'result' && fo !== -1) { view = 'q'; step = fo; redirected = true; }
      if (view === 'q' && fo !== -1 && (typeof step === 'number' ? step : state.step) > fo) { step = fo; redirected = true; }
      if (redirected && opts.fromHistory) { opts.fromHistory = false; opts.replace = true; }
      state.view = view;
      if (typeof step === 'number') state.step = step;
      root.setAttribute('data-view', view);
      if (view === 'intro') {
        stage.hidden = true;
        stage.innerHTML = '';
        intro.hidden = false;
      } else {
        intro.hidden = true;
        stage.hidden = false;
        stage.innerHTML = view === 'q' ? questionHtml(state.step) : resultHtml();
        stage.firstElementChild && stage.firstElementChild.classList.add(opts.back ? 'is-in-back' : 'is-in');
      }
      if (!opts.fromHistory) {
        var hs = { nfff: view === 'q' ? 'q' + state.step : view };
        try {
          if (opts.replace) history.replaceState(hs, '');
          else history.pushState(hs, '');
        } catch (e) {}
      }
      save();
      if (!opts.noScroll) scrollToTop(view === 'result');
      var heading = root.querySelector(view === 'intro' ? '#nf-ff-title' : '[data-ff-heading]');
      if (heading && !opts.noFocus) { try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); } }
      if (view === 'q') {
        announce('Frage ' + (state.step + 1) + ' von ' + total + ': ' + QUESTIONS[order[state.step]].q);
        /* nächste Frage vorladen, wenn ihre Bilder nicht von dieser Antwort abhängen (sonst beim Antworten) */
        var next = order[state.step + 1];
        if (next && (DEPENDS[next] || []).indexOf(order[state.step]) === -1) setTimeout(function () { preloadStep(state.step + 1); }, 0);
      }
      if (view === 'result') bindResult();
    }

    function progressHtml(step, done) {
      var segs = '';
      for (var i = 0; i < total; i++) segs += '<span class="' + (i < step || done ? 'is-done' : i === step ? 'is-now' : '') + '"></span>';
      var now = done ? total : step;
      return '<div class="nf-ff__progress" role="progressbar" aria-label="Fortschritt" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + now + '" aria-valuetext="' + (done ? 'Fertig' : 'Frage ' + (step + 1) + ' von ' + total) + '">' + segs + '</div>';
    }

    /* Front-Icons (choose-kitchen-*.png, quadratisch, Original 4289px): Front bei 10–63% Breite / 10–90% Höhe, rechts
       oben ein kleines Linien-Symbol → per CSS (.nf-ff__front) auf die Front zugeschnitten; das Bild ist 187,5% so breit
       wie die Front (sizes entsprechend) */
    function iconHtml(key, sizes) {
      var handle = key === 'simple+handle';
      var url = icons[handle ? 'simple' : key];
      return '<span class="nf-ff__front">' + pic(url, { ws: W_ICON, sizes: sizes || SZ.icon }) + (handle ? '<i class="nf-ff__handle" aria-hidden="true"></i>' : '') + '</span>';
    }

    function visualFor(id, val, a) {
      var fin = a.oberflaeche || 'Matt';
      switch (id) {
        case 'system': {
          var p = products[VIS.system[val]];
          if (!p) { var k = Object.keys(products).filter(function (h) { return val === 'METOD' ? h.indexOf('metod') !== -1 || h.indexOf('kuchen') === 0 : h.indexOf('schrank') === 0; })[0]; p = products[k]; }
          return '<span class="nf-ff__vis nf-ff__vis--photo">' + (p ? pic(p.hero, { ws: W_MID, sizes: SZ.opt2, nat: p.hw }) : '') + '</span>';
        }
        case 'oberflaeche': {
          var tiles = VIS.oberflaeche[val].map(function (n) { var s = sample(val, n); return s && s.img ? '<span>' + swatchPic(s, SZ.cell, 0) + '</span>' : ''; }).join('');
          return '<span class="nf-ff__vis nf-ff__vis--mosaic">' + tiles + '</span>';
        }
        /* echte Raumfotos: dasselbe Motiv in den drei Farben, die das Ergebnis bei dieser Antwort zeigen würde */
        case 'helligkeit':
          return photoTile(a.system || 'METOD', fin, FARBEN[farbKey(fin, val, 'offen')] || []);
        case 'temperatur':
          return photoTile(a.system || 'METOD', fin, FARBEN[farbKey(fin, a.helligkeit || 'mittel', val)] || []);
        case 'charakter': {
          var keys = VIS.charakter[val];
          if (!keys) {
            var sys = a.system || 'METOD';
            var m = CHAR_MARKANT.filter(function (s) { return available(s, sys, fin); })[0] || 'Iconic';
            keys = [STYLES[m].icon];
          }
          return '<span class="nf-ff__vis nf-ff__vis--icons">' + keys.map(iconHtml).join('') + '</span>';
        }
        case 'griffe':
          return '<span class="nf-ff__vis nf-ff__vis--icons' + (VIS.griffe[val].length > 1 ? ' is-pair' : '') + '">' + VIS.griffe[val].map(iconHtml).join('') + '</span>';
      }
      return '';
    }
    /* Unterzeilen einer Antwort (Liste = je eine Zeile) */
    function subFor(id, val, a) {
      if (id === 'oberflaeche') {
        var n = finishCount(val);
        return [FIN_SUB[val] || '', n ? n + (val === 'Matt' ? ' Farben' : ' Holztöne') : ''].filter(Boolean);
      }
      if (id === 'charakter' && val === 'rahmen' && a.oberflaeche) {
        var sys = a.system || 'METOD', fin = a.oberflaeche;
        var any = Object.keys(STYLES).some(function (s) { return STYLES[s].rahmen && available(s, sys, fin); });
        return any ? [] : ['nicht in ' + fin];
      }
      return [];
    }

    function questionHtml(step) {
      var id = order[step];
      var q = QUESTIONS[id];
      var a = answers();
      var opts = q.a.map(function (pair) {
        var val = pair[0], pressed = state.ans[id] === val;
        var sub = subFor(id, val, a).map(esc).join('<br>');
        return '<button type="button" class="nf-ff__opt" data-ff-answer="' + esc(val) + '" aria-pressed="' + pressed + '">' +
          visualFor(id, val, a) +
          '<span class="nf-ff__opt-text"><span class="nf-ff__opt-label">' + esc(pair[1]) + '</span>' + (sub ? '<span class="nf-ff__opt-sub">' + sub + '</span>' : '') + '</span>' +
          '<span class="nf-ff__tick" aria-hidden="true">' + ICON_CHECK + '</span>' +
          '</button>';
      }).join('');
      var showBack = step > 0 || !cfg.skipIntro || state.edit;
      return '<div class="nf-ff__view nf-ff__q" data-ff-q="' + id + '">' +
        '<div class="nf-ff__bar">' +
          (showBack ? '<button type="button" class="nf-ff__back" data-ff-back>' + ICON_BACK + '<span>Zurück</span></button>' : '<span></span>') +
          '<span class="nf-ff__count">Frage ' + (step + 1) + ' von ' + total + '</span>' +
        '</div>' +
        progressHtml(step, false) +
        '<h2 class="nf-ff__qtitle" data-ff-heading tabindex="-1" id="nf-ff-q-' + id + '">' + esc(q.q) + '</h2>' +
        '<div class="nf-ff__opts nf-ff__opts--' + q.a.length + ' nf-ff__opts--' + id + '" role="group" aria-labelledby="nf-ff-q-' + id + '">' + opts + '</div>' +
      '</div>';
    }

    function warumText(a, rec) {
      var picks = [];
      if (order.indexOf('charakter') !== -1) picks.push(quote(label('charakter', a.charakter)));
      /* „Rahmen + grifflos“: Rahmen gibt es nur mit Griff (steht im Hinweis) → „Grifflos“ hier nicht als erfüllt nennen */
      if (a.griffe !== 'egal' && !rec.hint) picks.push(quote(label('griffe', a.griffe)));
      return (picks.length ? 'Du hast ' + picks.join(' und ') + ' gewählt. ' : '') + (rec.why || STYLES[rec.style].warum);
    }
    function farbText(a, fin) {
      if (fin !== 'Matt' && a.temperatur === 'kühl') return TXT.hell[a.helligkeit] + TXT.tempHolz['kühl'];
      var n = finishCount(fin);
      var from = n ? ' – ausgewählt aus ' + n + (fin === 'Matt' ? ' matten Farben.' : ' Holztönen in ' + fin + '.') : '.';
      return TXT.hell[a.helligkeit] + (fin === 'Matt' ? TXT.temp : TXT.tempHolz)[a.temperatur] + from;
    }

    function resultHtml() {
      var a = answers();
      var rec = recommend(a);
      var fin = a.oberflaeche;
      var st = STYLES[rec.style];
      if (!pickedColors || pickedColors.length !== rec.colors.length) pickedColors = rec.colors.map(function () { return true; });
      var heroUrl = rec.heroUrl;
      var heroLabel = rec.style + ' in ' + (rec.heroColor || fin);
      var cards = rec.colors.map(function (s, i) {
        /* Raumfoto des empfohlenen Styles in dieser Farbe; fehlt es, das Raumfoto aus PHOTO (gleiches System +
           Oberfläche); sonst der Swatch */
        var front = rec.product && rec.product.c && rec.product.c[s.n];
        var nat = front && rec.product.d && rec.product.d[s.n] ? rec.product.d[s.n][0] : 0;
        if (!front) { var p = photoOf(a.system, fin, s.n); if (p) { front = p.url; nat = p.w; } }
        var vis = front
          ? '<span class="nf-ff__color-front">' + pic(front, { ws: W_MID, sizes: SZ.card, nat: nat }) + '</span><span class="nf-ff__color-chip">' + swatchPic(s, SZ.chip, 48, a.system) + '</span>'
          : '<span class="nf-ff__color-swatch">' + swatchPic(s, SZ.card, 160, a.system) + '</span>';
        return '<button type="button" class="nf-ff__color" data-ff-color="' + i + '" aria-pressed="' + (pickedColors[i] ? 'true' : 'false') + '" aria-label="' + esc(s.n + ' (' + s.f + ') – Gratis-Muster ' + (pickedColors[i] ? 'ausgewählt' : 'nicht ausgewählt')) + '">' +
          '<span class="nf-ff__color-vis">' + vis + '<span class="nf-ff__tick" aria-hidden="true">' + ICON_CHECK + '</span></span>' +
          '<span class="nf-ff__color-name">' + esc(s.n) + '</span>' +
          '<span class="nf-ff__color-sub">' + esc(s.f) + '</span>' +
        '</button>';
      }).join('');
      var chips = order.map(function (id, i) {
        return '<li><button type="button" class="nf-ff__ans" data-ff-edit="' + i + '"><span class="nf-ff__vh">Antwort ändern: ' + esc(QUESTIONS[id].q) + ' – </span>' + esc(label(id, state.ans[id])) + '</button></li>';
      }).join('');
      var altHtml = '';
      if (rec.alt) {
        var altH = styleHandle(rec.alt, a.system, fin);
        var altP = altH && products[altH];
        if (altP) {
          altHtml = '<a class="nf-ff__alt" href="' + esc(altP.u) + '" data-ff-cta="alternative">' +
            '<span class="nf-ff__alt-vis">' + iconHtml(STYLES[rec.alt].icon, SZ.iconAlt) + '</span>' +
            '<span class="nf-ff__alt-text"><span class="nf-ff__alt-kicker">Auch passend</span><span class="nf-ff__alt-name">' + esc(rec.alt) + ' in ' + esc(fin) + '</span></span>' +
            '<span class="nf-ff__alt-go" aria-hidden="true">' + ICON_NEXT + '</span></a>';
        }
      }
      var hintHtml = rec.hint ? '<p class="nf-ff__hint">' + ICON_INFO + '<span>' + esc(rec.hint) + '</span></p>' : '';
      var colorWord = fin === 'Matt' ? 'Farben' : 'Holztöne';

      /* Die 3 Farben sind nur der Start: alle Muster sind gratis, „Passt auch“ legt weitere dazu */
      var moreItems = rec.more.map(function (s, i) {
        var on = !!pickedMore[s.n];
        return '<button type="button" class="nf-ff__more-item" data-ff-more="' + i + '" aria-pressed="' + on + '" aria-label="' + esc(moreLabel(s, on)) + '">' +
          '<span class="nf-ff__more-vis">' + swatchPic(s, SZ.more, 64, a.system) +
            '<span class="nf-ff__tick" aria-hidden="true">' + ICON_CHECK + ICON_PLUS + '</span></span>' +
          '<span class="nf-ff__more-name">' + esc(s.n) + '</span>' +
        '</button>';
      }).join('');
      var moreHtml = (cfg.free ? '<p class="nf-ff__free">' + ICON_GIFT + '<span><strong>Alle Muster sind gratis</strong> – nimm so viele, wie du magst.</span></p>' : '') +
        (moreItems ? '<div class="nf-ff__more">' +
          '<p class="nf-ff__more-title" id="nf-ff-more-title">Passt auch <span>– antippen zum Dazulegen</span></p>' +
          '<div class="nf-ff__more-row" role="group" aria-labelledby="nf-ff-more-title">' + moreItems + '</div>' +
        '</div>' : '');

      return '<div class="nf-ff__view nf-ff__result" data-ff-result>' +
        progressHtml(total, true) +
        '<div class="nf-ff__result-grid">' +
          '<div class="nf-ff__result-media">' +
            '<figure class="nf-ff__hero">' + (heroUrl ? pic(heroUrl, { ws: W_BIG, sizes: SZ.hero, nat: rec.heroNat, cls: 'nf-ff__hero-img', alt: 'Beispielfoto: ' + heroLabel }) : '') +
              '<figcaption>Beispiel: ' + esc(heroLabel) + '</figcaption></figure>' +
          '</div>' +
          '<div class="nf-ff__result-body">' +
            '<p class="nf-ff__kicker">Dein Ergebnis</p>' +
            '<h2 class="nf-ff__rtitle" data-ff-heading tabindex="-1">' + esc(rec.style) + '</h2>' +
            '<p class="nf-ff__rsub">' + esc(st.zusatz) + ' · ' + esc(fin) + ' · ' + esc(TXT.systemFor[a.system]) + '</p>' +
            '<div class="nf-ff__why"><p><strong>Warum das passt:</strong> ' + esc(warumText(a, rec)) + '</p></div>' +
            hintHtml +
            '<h3 class="nf-ff__h3">Deine ' + rec.colors.length + ' ' + colorWord + '</h3>' +
            '<p class="nf-ff__colors-why">' + esc(farbText(a, fin)) + '</p>' +
            '<div class="nf-ff__colors" role="group" aria-label="Deine ' + colorWord + ' als Gratis-Muster">' + cards + '</div>' +
            moreHtml +
            '<div class="nf-ff__cta">' +
              '<button type="button" class="nf-ff__btn nf-ff__btn--primary nf-ff__btn--wide" data-ff-cart></button>' +
              '<p class="nf-ff__cta-note" data-ff-cart-note></p>' +
              '<p class="nf-ff__error" data-ff-error role="alert" hidden></p>' +
              '<a class="nf-ff__textlink nf-ff__textlink--center" href="' + esc(cfg.moreUrl || '/collections/muster') + '" data-ff-cta="mehr_muster">Alle Muster ansehen' + ICON_NEXT + '</a>' +
              '<div class="nf-ff__or"><span>oder</span></div>' +
              '<a class="nf-ff__btn nf-ff__btn--secondary nf-ff__btn--wide" href="' + esc(cfg.angebotUrl || '/pages/gratis-angebot') + '" data-ff-cta="angebot">Gratis-Angebot anfordern</a>' +
            '</div>' +
            altHtml +
            (rec.product ? '<a class="nf-ff__textlink" href="' + esc(rec.product.u) + '" data-ff-cta="style">' + esc(rec.style) + ' in ' + esc(fin) + ' im Konfigurator ansehen' + ICON_NEXT + '</a>' : '') +
            '<div class="nf-ff__answers"><p class="nf-ff__answers-title">Deine Antworten <span>(antippen zum Ändern)</span></p><ul>' + chips + '</ul></div>' +
            '<button type="button" class="nf-ff__restart" data-ff-restart>' + ICON_RESTART + '<span>Nochmal starten</span></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    /* ---------------- Ergebnis: Muster wählen + Warenkorb ---------------- */
    var lastRec = null;
    function colorLabel(s, on) { return s.n + ' (' + s.f + ') – ' + (inCart[s.id] ? 'liegt im Warenkorb' : 'Gratis-Muster ' + (on ? 'ausgewählt' : 'nicht ausgewählt')); }
    function moreLabel(s, on) { return s.n + ' (' + s.f + ') – ' + (inCart[s.id] ? 'liegt im Warenkorb' : 'Gratis-Muster ' + (on ? 'ausgewählt' : 'dazulegen')); }
    function bindResult() {
      lastRec = recommend(answers());
      updateCartButton();
      /* ff_result einmal je Durchlauf (nicht nach Neuladen, Zurück/Vor oder „Antwort ändern“ ohne Änderung) */
      if (state.tracked !== state.run) {
        state.tracked = state.run;
        save();
        track('result', { system: state.ans.system, oberflaeche: state.ans.oberflaeche, style: lastRec.style, farben: lastRec.colors.map(function (s) { return s.n; }).join(', '), ersatz: !!(lastRec.why || lastRec.hint) });
      }
      sendSurvey(lastRec);
      syncCart();
      announce('Dein Ergebnis: ' + lastRec.style + ' in ' + state.ans.oberflaeche + ', mit ' + lastRec.colors.length + ' Farben.');
    }
    /* gewählte Muster: die 3 Farben (an/aus) + angetippte „Passt auch“-Farben; was im Warenkorb liegt, bleibt gewählt */
    function selectedSamples() {
      if (!lastRec) return [];
      return lastRec.colors.filter(function (s, i) { return pickedColors[i] || inCart[s.id]; })
        .concat((lastRec.more || []).filter(function (s) { return !!pickedMore[s.n] || inCart[s.id]; }));
    }
    /* Muster dieses Ergebnisses, die im Warenkorb liegen */
    function cartSamples() {
      return lastRec ? lastRec.colors.concat(lastRec.more || []).filter(function (s) { return inCart[s.id]; }) : [];
    }
    /* Karten an den Warenkorb anpassen: liegt ein Muster drin, bleibt es gewählt (Abwählen nähme es nicht heraus) */
    function paintPicks() {
      if (!lastRec) return;
      Array.prototype.forEach.call(root.querySelectorAll('[data-ff-color]'), function (b) {
        var i = +b.getAttribute('data-ff-color'), s = lastRec.colors[i];
        if (!s) return;
        if (inCart[s.id]) pickedColors[i] = true;
        b.setAttribute('aria-pressed', pickedColors[i] ? 'true' : 'false');
        b.setAttribute('aria-label', colorLabel(s, pickedColors[i]));
        b.toggleAttribute('data-incart', !!inCart[s.id]);
        var sub = b.querySelector('.nf-ff__color-sub');
        if (sub) sub.textContent = inCart[s.id] ? 'Im Warenkorb' : s.f;
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-ff-more]'), function (b) {
        var s = (lastRec.more || [])[+b.getAttribute('data-ff-more')];
        if (!s) return;
        if (inCart[s.id]) pickedMore[s.n] = true;
        b.setAttribute('aria-pressed', pickedMore[s.n] ? 'true' : 'false');
        b.setAttribute('aria-label', moreLabel(s, pickedMore[s.n]));
        b.toggleAttribute('data-incart', !!inCart[s.id]);
      });
    }
    /* Knopf zählt nur, was noch nicht im Warenkorb liegt („1 weiteres Gratis-Muster …“) */
    function updateCartButton() {
      var btn = root.querySelector('[data-ff-cart]');
      var note = root.querySelector('[data-ff-cart-note]');
      if (!btn) return;
      paintPicks();
      var all = selectedSamples();
      var sel = all.filter(function (s) { return !inCart[s.id]; });
      var have = all.length - sel.length;
      var n = sel.length;
      var allFree = sel.every(function (s) { return !s.p; });
      cartDone = !n && have > 0;
      if (cartDone) {
        btn.innerHTML = ICON_CHECK + '<span>Im Warenkorb – ansehen</span>';
        btn.setAttribute('data-state', 'done');
        btn.removeAttribute('aria-disabled');
      } else if (!n) {
        btn.innerHTML = '<span>Wähle mindestens 1 Muster</span>';
        btn.setAttribute('aria-disabled', 'true');
        btn.removeAttribute('data-state');
      } else {
        btn.innerHTML = '<span>' + n + (have ? (n === 1 ? ' weiteres' : ' weitere') : '') + (allFree ? ' Gratis-Muster' : ' Muster') + ' in den Warenkorb</span>';
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-state');
      }
      if (note) {
        var cost = sel.reduce(function (sum, s) { return sum + (s.p || 0); }, 0);
        note.textContent = cartDone
          ? 'Liegt im Warenkorb. Du kannst jederzeit weitere Muster dazulegen.'
          : (allFree ? 'Gratis' : price(cost)) + ' · je 5 × 5 cm' + (have ? ' · ' + have + (have === 1 ? ' liegt' : ' liegen') + ' schon im Warenkorb' : '');
      }
    }
    /* Warenkorb-Stand holen (Ergebnis anzeigen, Drawer zu, „ansehen“); ein späteres Hinzufügen macht ihn ungültig */
    var cartSeq = 0;
    function cartIds(cart) {
      var m = {};
      ((cart && cart.items) || []).forEach(function (it) { if (sampleIds[it.variant_id]) m[it.variant_id] = true; });
      return m;
    }
    function syncCart() {
      var my = ++cartSeq;
      try {
        fetch(cfg.cartJs || '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart || my !== cartSeq || busy) return;
            inCart = cartIds(cart);
            updateCartButton();
          }, function () {});
      } catch (e) {}
    }
    function showError(msg) {
      var el = root.querySelector('[data-ff-error]');
      if (!el) return;
      el.innerHTML = msg;
      el.hidden = !msg;
    }
    function openDrawer() {
      try { if (window.NFCart && typeof window.NFCart.open === 'function') { window.NFCart.open(); return; } } catch (e) {}
      location.href = (cfg.root || '/') + 'cart';
    }
    function ensureDrawer() {
      setTimeout(function () {
        if (!document.documentElement.classList.contains('m6pn-open')) openDrawer();
      }, 1500);
    }
    /* Warenkorb-Attribut: die Bestellung trägt das Quiz-Ergebnis (Admin → Bestellung → Zusätzliche Details). Ohne
       Unterstrich, damit es im Admin sichtbar bleibt; der Checkout zeigt Warenkorb-Attribute ohnehin nicht. */
    var ATTR_KEY = 'Front-Finder';
    function attrValue(sel) {
      var rec = lastRec || {};
      return order.map(function (id) { return state.ans[id]; }).join(' · ') +
        (kurz ? ' (Kurzfassung)' : '') + ' → ' + (rec.style || '') +
        ' · Muster: ' + sel.map(function (s) { return s.n; }).join(', ');
    }
    function setCartAttr(sel) {
      var attrs = {};
      attrs[ATTR_KEY] = attrValue(sel).slice(0, 250);
      return fetch(cfg.cartUpdate || '/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () {}, function () {});
    }
    function addToCart(btn) {
      if (busy) return;
      if (cartDone) { track('cta', { cta: 'warenkorb_ansehen' }); openDrawer(); syncCart(); return; }
      var sel = selectedSamples().filter(function (s) { return !inCart[s.id]; });
      if (!sel.length) return;
      busy = true;
      cartSeq++;
      var added = 0;
      showError('');
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = '<span>Wird hinzugefügt …</span>';
      fetch(cfg.cartJs || '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (it) { have[it.variant_id] = true; });
          inCart = cartIds(cart);
          /* der Warenkorb zeigt das zuletzt Hinzugefügte oben → umgekehrt senden, damit Farbe 1 oben steht */
          var items = sel.filter(function (s) { return !have[s.id]; }).reverse().map(function (s) {
            return { id: s.id, quantity: 1, properties: { 'System': state.ans.system, 'Oberfläche': s.f, 'Größe': '5 x 5 cm' } };
          });
          added = items.length;
          if (!items.length) { openDrawer(); return true; }
          return fetch(cfg.cartAdd || '/cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (r) {
            if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { var e = new Error(j.description || j.message || 'HTTP ' + r.status); e.status = r.status; throw e; });
            ensureDrawer();
            return true;
          });
        })
        .then(function () {
          sel.forEach(function (s) { inCart[s.id] = true; });
          /* Attribut + Ereignis aus allem, was von diesem Ergebnis im Warenkorb liegt (nicht nur dem letzten Klick) */
          var now = cartSamples();
          var extra = now.filter(function (s) { return lastRec && lastRec.colors.indexOf(s) === -1; }).length;
          track('cart', { anzahl: added, gesamt: now.length, zusatz: extra, style: lastRec && lastRec.style, farben: now.map(function (s) { return s.n; }).join(', ') });
          return setCartAttr(now);
        })
        .catch(function (err) {
          var more = esc(cfg.moreUrl || '/collections/muster');
          showError((err && err.status === 429 ? 'Gerade gehen zu viele Anfragen ein. Bitte versuch es in ein paar Minuten nochmal' : 'Das hat leider nicht geklappt. Bitte versuch es nochmal') +
            ' – oder <a href="' + more + '">wähle die Muster direkt aus</a>.');
          try { console.warn('[NF Front-Finder] Warenkorb:', err); } catch (e) {}
        })
        .then(function () {
          busy = false;
          btn.removeAttribute('aria-busy');
          updateCartButton();
        });
    }

    /* ---------------- Antworten ---------------- */
    var advancing = false;
    function answer(btn) {
      if (advancing) return;
      var id = order[state.step];
      var val = btn.getAttribute('data-ff-answer');
      var changed = state.ans[id] !== val;
      state.ans[id] = val;
      if (changed) {
        pickedColors = null;
        pickedMore = {};
        /* Antwort nach dem Ergebnis geändert → neuer Durchlauf (eigener Umfrage-Eintrag, als „Antwort geändert“) */
        if (state.tracked === state.run || state.sent === state.run) { state.run = newRun(); state.kind = 'geändert'; }
      }
      Array.prototype.forEach.call(btn.parentNode.children, function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      btn.classList.add('is-picked');
      track('answer', { frage: id, antwort: val, schritt: state.step + 1 });
      /* Bilder des nächsten Schritts sofort anfragen (die Ansicht wechselt erst nach 260 ms) */
      var fo0 = firstOpen();
      preloadStep(fo0 === -1 && (state.edit || state.step + 1 >= total) ? total : fo0 !== -1 && fo0 < state.step ? fo0 : state.step + 1);
      advancing = true;
      setTimeout(function () {
        advancing = false;
        /* aus dem Ergebnis geändert oder letzte Frage → Ergebnis, aber nur mit allen Antworten; fehlt eine
           (z. B. per Browser-Zurück auf eine leere Frage gekommen), geht es zur ersten offenen Frage */
        var fo = firstOpen();
        if (fo === -1 && (state.edit || state.step + 1 >= total)) { state.edit = false; show('result'); return; }
        show('q', fo !== -1 && fo < state.step ? fo : state.step + 1);
      }, reduceMotion() ? 60 : 260);
    }

    function goBack() {
      if (state.view === 'q') {
        if (state.edit) { state.edit = false; show('result', null, { back: true }); return; }
        if (state.step > 0) show('q', state.step - 1, { back: true });
        else if (!cfg.skipIntro) show('intro');
      } else if (state.view === 'result') {
        show('q', total - 1, { back: true });
      }
    }

    /* Vorladen nur des nächsten Schritts (Bildgewicht): die Kacheln der nächsten Frage einmal unsichtbar bauen – der
       Browser holt dieselben srcset-Dateien wie später sichtbar; nach der letzten Frage Ergebnisfoto + Farbkarten */
    var prepared = {};
    function preloadStep(step) {
      if (step >= total) { preloadResult(); return; }
      var key = step + '|' + JSON.stringify(state.ans);
      if (prepared[key]) return;
      prepared[key] = true;
      try { document.createElement('div').innerHTML = questionHtml(step); } catch (e) {}
    }
    function preloadResult() {
      if (!complete()) return;
      var a = answers(), r = recommend(a);
      if (r.heroUrl) preload(r.heroUrl, { ws: W_BIG, sizes: SZ.hero, nat: r.heroNat });
      if (r.product) r.colors.forEach(function (c) {
        var f = r.product.c && r.product.c[c.n];
        if (f) preload(f, { ws: W_MID, sizes: SZ.card, nat: r.product.d && r.product.d[c.n] ? r.product.d[c.n][0] : 0 });
      });
    }

    function start() {
      state.ans = {};
      state.edit = false;
      state.run = newRun();
      /* schon ein Ergebnis in dieser Sitzung gesehen → „Nochmal gestartet“ */
      state.kind = state.tracked ? 'neu' : 'erster';
      pickedColors = null;
      pickedMore = {};
      track('start', {});
      show('q', 0);
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button, a') : null;
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-ff-start')) { start(); return; }
      if (t.hasAttribute('data-ff-answer')) { answer(t); return; }
      if (t.hasAttribute('data-ff-back')) { goBack(); return; }
      if (t.hasAttribute('data-ff-color')) {
        var i = +t.getAttribute('data-ff-color');
        var s = lastRec && lastRec.colors[i];
        if (!s) return;
        if (inCart[s.id]) { announce(s.n + ' liegt schon im Warenkorb.'); return; }
        pickedColors[i] = !pickedColors[i];
        updateCartButton();
        return;
      }
      if (t.hasAttribute('data-ff-more')) {
        var m = lastRec && lastRec.more && lastRec.more[+t.getAttribute('data-ff-more')];
        if (!m) return;
        if (inCart[m.id]) { announce(m.n + ' liegt schon im Warenkorb.'); return; }
        pickedMore[m.n] = !pickedMore[m.n];
        updateCartButton();
        return;
      }
      if (t.hasAttribute('data-ff-cart')) { if (t.getAttribute('aria-disabled') !== 'true') addToCart(t); return; }
      if (t.hasAttribute('data-ff-edit')) { state.edit = true; show('q', +t.getAttribute('data-ff-edit')); return; }
      if (t.hasAttribute('data-ff-restart')) {
        track('cta', { cta: 'neustart' });
        /* alte Antworten merken: Browser-Zurück direkt nach „Nochmal starten“ zeigt wieder das alte Ergebnis */
        prevAns = complete() ? state.ans : null;
        prevRun = { run: state.run, sent: state.sent, tracked: state.tracked, kind: state.kind };
        clearStore(); state.ans = {}; pickedColors = null; pickedMore = {};
        if (cfg.skipIntro) start(); else show('intro');
        return;
      }
      if (t.hasAttribute('data-ff-cta')) { track('cta', { cta: t.getAttribute('data-ff-cta'), style: lastRec && lastRec.style }); }
    });

    window.addEventListener('popstate', function (e) {
      var s = e.state && e.state.nfff;
      if (!s) return;
      if (s === 'intro') { show('intro', null, { fromHistory: true }); return; }
      /* noch nichts Neues beantwortet → Einträge des vorigen Durchlaufs zeigen dessen Antworten wieder */
      /* … samt Durchlauf: das alte Ergebnis wird weder neu gezählt noch neu gesendet */
      if (prevAns && firstOpen() === 0) {
        state.ans = prevAns; pickedColors = null; pickedMore = {};
        if (prevRun) { state.run = prevRun.run; state.sent = prevRun.sent; state.tracked = prevRun.tracked; state.kind = prevRun.kind; }
      }
      prevAns = null; prevRun = null;
      if (s === 'result') { show('result', null, { fromHistory: true, back: true }); return; }
      var n = parseInt(s.slice(1), 10);
      if (!isNaN(n) && n < total) show('q', n, { fromHistory: true, back: n < state.step });
    });

    /* Drawer geschlossen (dort kann man Muster entfernen) → Stand neu holen, damit Knopf und Karten stimmen */
    try {
      var drawerOpen = false;
      new MutationObserver(function () {
        var open = document.documentElement.classList.contains('m6pn-open');
        if (drawerOpen && !open && state.view === 'result') syncCart();
        drawerOpen = open;
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}

    /* Zähltexte der Startansicht an den Modus anpassen (6 bzw. 4 Fragen, je ~5 s) */
    var fc = root.querySelector('[data-ff-fact-count]');
    var ft = root.querySelector('[data-ff-fact-time]');
    if (fc) fc.textContent = total + ' kurze Fragen';
    if (ft) ft.textContent = 'ca. ' + (total * 5) + ' Sekunden';

    /* Start: gespeicherten Stand dieser Sitzung wiederherstellen, sonst Startansicht */
    var saved = load();
    if (saved && saved.ans) {
      state.ans = saved.ans;
      if (saved.run) { state.run = saved.run; state.sent = saved.sent || ''; state.tracked = saved.tracked || ''; state.kind = saved.kind || 'erster'; }
      /* show() begrenzt auf die erste offene Frage (ein unvollständiger Stand führt nie zum Ergebnis) */
      if (saved.view === 'result') show('result', null, { replace: true, noScroll: true, noFocus: true });
      else if (saved.view === 'q' && saved.step < total) show('q', saved.step, { replace: true, noScroll: true, noFocus: true });
      else if (cfg.skipIntro) show('q', 0, { replace: true, noScroll: true, noFocus: true });
      else show('intro', null, { replace: true, noScroll: true, noFocus: true });
    } else if (cfg.skipIntro) {
      show('q', 0, { replace: true, noScroll: true, noFocus: true });
    } else {
      try { history.replaceState({ nfff: 'intro' }, ''); } catch (e) {}
    }
    root.classList.add('is-ready');
    /* für Tests im Browser: document.getElementById('nf-ff')._ffRecommend({system:'METOD', …}) */
    root._ffRecommend = recommend;
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-nf-ff]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
